import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks/useAppDispatch";
import { loadMetaData } from "../store/thunks/metaDataThunks";

const useMetaDataInitialization = (shouldLoad: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (shouldLoad) {
      dispatch(loadMetaData());
    }
  }, [shouldLoad, dispatch]);
};

export default useMetaDataInitialization;
